// Camera-domain locations client.
//
// /api/locations returns the camera-domain shape (location_id, display_name,
// camera_count, online_camera_count, address?, timezone?, updated_at). The
// Cameras page consumes this; the appstore-admin page uses `locationsClient`,
// which is typed against a different (admin-only) shape.

import { api } from "./client";

export interface CameraDomainLocation {
  location_id: string;
  display_name: string;
  camera_count: number;
  online_camera_count: number;
  address?: string | null;
  timezone?: string | null;
  updated_at: string | null;
}

interface ListResponse {
  items: CameraDomainLocation[];
  next_cursor: string | null;
}

export const cameraLocationsClient = {
  async list(signal?: AbortSignal): Promise<CameraDomainLocation[]> {
    const res = await api.get<ListResponse>("/api/locations", { signal });
    return res.items ?? [];
  },
};
